import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { MainContent, PageHeading } from '../../components/Shell/Content';
import LoadingSkeleton from '../../components/Shell/LoadingSkeleton';
import { TemplateDropdown } from '../../components/Attributes/Attributes_old';
import DataTable from '../../components/DataTable';
import useAxios from '../../hooks/useAxios';
import useAsync from '../../hooks/useAsync';
import { getAllSources } from '../../api/sources';
import LarianTechBSCUsageWidget from '../../components/Widgets/LarianTechBSCUsageWidget';

const Insights = () => {
	const navigate = useNavigate();
	const [form, setForm] = useState({ period: '1' });

	const {
		value: response,
		execute: onCallEndpoint,
		status: loadingData,
	} = useAxios();
	const { value: sources, status: loadingSources } = useAsync(getAllSources);

	const selectedSource = sources?.find((source) => source.id === form?.source);
	const selectedMetric = selectedSource?.integration_source_metrics?.find(
		(metric) => metric?.id === form?.metric
	);

	const sourceURL = selectedSource
		? `${selectedSource?.integration?.apiUrl}${selectedSource?.url}`
		: null;
	const sourceMethod = selectedSource?.method;
	const sourceApiKey = selectedSource?.integration?.organizations?.length
		? selectedSource?.integration?.organizations[0]?.organization_integration
				?.apiKey
		: null;

	useEffect(() => {
		if (selectedSource && selectedMetric) {
			onCallEndpoint(sourceURL, {
				method: sourceMethod,
				data: {
					from:
						form?.period === '1'
							? moment().utc().startOf('D').format('YYYY-MM-DD HH:mm:SS')
							: form?.period === 'custom'
							? ''
							: moment()
									.utc()
									.startOf('D')
									.subtract(form?.period, 'days')
									.format('YYYY-MM-DD HH:mm:SS'),
					to: moment().utc().format('YYYY-MM-DD HH:mm:SS'),
					...selectedMetric?.configuration,
				},
				headers: {
					'x-api-key': sourceApiKey,
				},
			});
		}
	}, [selectedSource, selectedMetric, form?.period]);

	const raw =
		response &&
		Object.keys(response?.records).flatMap((deviceId) => {
			const max = response?.records[deviceId]?.length;

			const data = [
				...response?.records[deviceId].map((rec, i) => {
					return i < 15 ? { ...rec, door: '1' } : rec;
				}),
			];

			return data.map((record) => ({
				deviceId,
				data: JSON.stringify({
					//temperature: record?.temperature || 'N/A',
					//humidity: record?.humidity || 'N/A',
					//co2: record?.co2 || 'N/A',
					door: record?.door
						? record?.door === '1'
							? 'In use'
							: record?.door === '2'
							? 'Not connected'
							: 'Not in use'
						: 'Not in use',
				}),
				time: record?.time,
			}));
		});

	const data = response ? raw : { rows: [] };

	let adjusted = [];

	const DELAY = 15;

	const groupedData = response
		? Object.keys(response?.records).map((deviceId) => {
				const max = response?.records[deviceId]?.length;
				const data = [...response?.records[deviceId]];

				let start = null;
				let last = null;
				let end = null;

				let active = null;

				data.reverse().map((point, i) => {
					if (!start && !point?.door) {
						// No start point
						// No door data

						//console.log('Status: NOT active, no door');
						return;
					}
					if (!start && point?.door === '1') {
						// No start point
						// Door first opened

						start = point;
						last = point;
						//console.log('Status: NOT active, door first opened');
						return;
					}
					if (start && point?.door === '1') {
						// Active usage
						// Door opened

						if (end) {
							end = null;
						}

						active = {
							deviceId,
							data: {
								label: `Actively used: ${moment
									.duration(moment().utc().diff(moment(start?.time)))
									.humanize({ m: 60, h: 24 })}`,
								duration: moment
									.duration(moment().utc().diff(moment(start?.time)))
									.asMilliseconds(),
							},
							time: moment().utc().format(),
						};

						last = point;
						//console.log('Status: active usage, door open');
						return;
					}
					if (
						start &&
						(!point?.door || point?.door === '2' || point?.door === '0')
					) {
						// Active usage
						// Door first closed

						//console.log('Status: active usage, door first closed');
						//console.log('Status: point time(): ', moment.utc(point?.time));
						//console.log('Status: end time(): ', moment.utc(end?.time));
						//console.log('Status: last time(): ', moment.utc(last?.time));
						//console.log(
						//	'Status: diff time(): ',
						//		moment.utc(point?.time) <=
						//			moment.utc(end?.time || last?.time).add(15, 'm')
						//	);

						if (
							moment.utc(point?.time) <=
							moment.utc(end?.time || last?.time).add(15, 'm')
						) {
							// within 15 min delay
							if (!end) {
								end = last;
							}
						} else {
							//console.log('Status: END WORK', start?.time, end?.time);
							// not within 15 minute delay, end work
							adjusted.push({
								deviceId,
								data: {
									label: `Used for: ${moment
										.duration(moment(end?.time).utc().diff(moment(start?.time)))
										.humanize({ m: 60, h: 24 })}`,
									duration: moment
										.duration(moment(end?.time).utc().diff(moment(start?.time)))
										.asMilliseconds(),
								},
								time: end?.time,
							});
							start = null;
							end = null;
							active = null;
						}

						// END === last working point
						// If current point < 15 minutes from END, continue
						// Else
						// ADD ADJUST, end === last working point

						//start = null;
						last = point;
						return;
					}
					last = point;
				});

				if (active) {
					adjusted.push(active);
					active = null;
				}

				return data;
		  })
		: { rows: [] };

	return (
		<MainContent>
			<PageHeading
				divider={false}
				/*actions={/*[
					{
						name: 'Refresh data',
						onClick: () => {},
						type: 'secondary',
						disabled: true,
					},
				]}*/
				//onBack={() => navigate(`/insights`)}
			>
				View Insights
			</PageHeading>

			<div className="grid grid-cols-8 gap-x-4 gap-y-8">
				<TemplateDropdown
					span="sm:col-span-3"
					name="Source"
					options={sources?.map((source) => ({
						label: `${source?.integration?.name} - ${source?.name}`,
						value: source.id,
					}))}
					onChange={(index, source) => setForm({ ...form, source })}
					value={form?.source}
					disabled={loadingSources === 'pending'}
					placeholder={
						loadingSources === 'pending' ? 'Loading...' : 'Select a source'
					}
				/>
				<TemplateDropdown
					name="Metric"
					options={
						form?.source
							? [
									//{ label: 'Raw data', value: 'raw' },
									...(selectedSource
										? selectedSource?.integration_source_metrics?.map(
												(metric) => ({
													label: metric?.name,
													value: metric?.id,
												})
										  )
										: [{}]),
							  ]
							: []
					}
					onChange={(index, metric) => setForm({ ...form, metric })}
					value={form?.metric}
					disabled={loadingSources === 'pending' || !form?.source}
					placeholder={
						loadingSources === 'pending' ? 'Loading...' : 'Select a metric'
					}
				/>
				<TemplateDropdown
					name="Period"
					options={[
						{ label: 'Today', value: '1' },
						{ label: 'Last 7 days', value: '7' },
						{ label: 'Last 14 days', value: '14' },
						{ label: 'Last 30 days', value: '30' },
						//{ label: 'Custom Date', value: 'custom' },
					]}
					onChange={(index, period) => setForm({ ...form, period })}
					value={form?.period}
				/>
			</div>

			<div>
				{loadingData === 'pending' ? (
					<div className="mt-10">
						<LoadingSkeleton />
					</div>
				) : loadingData === 'error' ? (
					<div>Failed to load data</div>
				) : (
					<>
						{adjusted?.length ? (
							<>
								<div className="my-10 grid grid-cols-4 gap-6">
									<LarianTechBSCUsageWidget data={adjusted} />
								</div>
								<DataTable
									title="All data points"
									data={
										response
											? {
													rows: adjusted.sort((x, y) => {
														return new Date(x.time) < new Date(y.time) ? 1 : -1;
													}),
											  }
											: { rows: [] }
									}
									columns={[
										{
											header: 'DEVICE ID',
											accessorKey: 'deviceId',
											cell: (info) => info?.getValue() || null,
										},
										{
											header: 'DATA',
											accessorKey: 'data.label',
											cell: (info) => info?.getValue() || null,
										},
										{
											header: 'TIMESTAMP',
											accessorKey: 'time',
											cell: (info) => info?.getValue() || null,
										},
									]}
									usePagination={false}
									useExport={false}
									hasCheckboxes={false}
								/>
							</>
						) : null}
					</>
				)}
			</div>
		</MainContent>
	);
};

export default Insights;
